export default {
  'Custom': 'Custom',
  'Original': 'Asli',
}